module.exports = __webpack_public_path__ + "static/online-d6719086c130ef1873d14b5178b21bae.png";